var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "or-sidebar",
    {
      attrs: {
        "data-component": "base-settings-menu-sidebar",
        placement: "left",
        resizeable: false,
        width: _vm.SIDEBAR_WIDTH,
      },
    },
    [
      _c(
        "div",
        { staticClass: "menu-groups" },
        _vm._l(_vm.menuGroups, function (group) {
          return _c("base-settings-menu-group", {
            key: group.title,
            attrs: { group: group, "active-item-id": _vm.activeMenuItemId },
            on: {
              "item-click": function ($event) {
                return _vm.$emit("item-click", $event)
              },
            },
          })
        }),
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }